import React from "react";
import Grid from "../../../Grid/Grid";
import "./home-why.scss";

import MoneyIcon from "../../../../assets/icons/icons_money.svg";
import CharityIcon from "../../../../assets/icons/icons_charity.svg";
import ConnectingIcon from "../../../../assets/icons/icons_connecting.svg";
import GrowthIcon from "../../../../assets/icons/icons_growth.svg";
import LoyaltyIcon from "../../../../assets/icons/icons_loyalty.svg";

const HomeWhy = () => {
  return (
    <section className="home-why">
      <Grid className="home-why__grid">
        <h2 className="home-why__heading">Why use AskTheStar?</h2>
        <div className="home-why__container">
          <div className="home-why__card">
            <MoneyIcon className="home-why__card__icon" />
            <h3 className="home-why__card__title">Boost Your Income</h3>
            <p className="home-why__card__text">
              Get compensated for your time, while answering meaningful
              questions.
            </p>
          </div>
          <div className="home-why__card">
            <CharityIcon className="home-why__card__icon" />
            <h3 className="home-why__card__title">
              Make The World a Better Place
            </h3>
            <p className="home-why__card__text">
              You may choose to donate a portion of your proceeds to a charity
              of your choice.
            </p>
          </div>
          <div className="home-why__card">
            <ConnectingIcon className="home-why__card__icon" />
            <h3 className="home-why__card__title">Get to Know Your Audience</h3>
            <p className="home-why__card__text">
              Learn what’s important to your fans, by engaging them directly.
            </p>
          </div>
          <div className="home-why__card">
            <GrowthIcon className="home-why__card__icon" />
            <h3 className="home-why__card__title">Grow Your Following</h3>
            <p className="home-why__card__text">
              Our growing platform can bring attention to your profile,
              introducing you to new fans.
            </p>
          </div>
          <div className="home-why__card">
            <LoyaltyIcon className="home-why__card__icon" />
            <h3 className="home-why__card__title">Increase Loyalty</h3>
            <p className="home-why__card__text">
              By connecting with your most dedicated fans, you’ll build stronger
              relationships.
            </p>
          </div>
        </div>
      </Grid>
    </section>
  );
};

export default HomeWhy;
